package com.downdogapp.client.controllers

import com.downdogapp.client.ViewController
import com.downdogapp.client.api.Song
import com.downdogapp.client.singleton.App
import com.downdogapp.client.views.PlaylistView

class PlaylistViewController(val songs: List<Song>) : ViewController() {

  override val view = PlaylistView(this)

  fun onSongClicked(song: Song) {
    App.pushViewController(
      SongViewController(song)
    )
  }
}
